import { combineReducers } from 'redux';
import customRoutesFilter from './customRoutesFilter';

export default combineReducers({ customRoutesFilter });
